export function PupLogo({ className = "size-6" }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="AnimePup"
      className={className}
      draggable={false}
    />
  );
}
